import { outdent } from 'outdent';

const SITE_COMPONENT_HMR_PARAMETER = 'site-component-hmr';
export const SITE_COMPONENT_HMR_PARAMETER_RE = new RegExp(
  `[?&]${SITE_COMPONENT_HMR_PARAMETER}\\b`
);

const SITE_COMPONENT_SDK_HMR_PARAMETER = 'site-component-sdk-hmr';
export const SITE_COMPONENT_SDK_HMR_PARAMETER_RE = new RegExp(
  `[?&]${SITE_COMPONENT_SDK_HMR_PARAMETER}\\b`
);

export const getSiteComponentPathWithHMR = (relativePath: string) =>
  `/${relativePath}?${SITE_COMPONENT_HMR_PARAMETER}`;

export const getSiteComponentSdkPathWithHMR = (relativePath: string) =>
  `/${relativePath}?${SITE_COMPONENT_SDK_HMR_PARAMETER}`;

export const getSiteComponentSdkHMRTemplate = (id: string, root: string) => {
  const originalId = id
    .replace(SITE_COMPONENT_SDK_HMR_PARAMETER_RE, '')
    .replace(root, '');

  // TODO: implement HMR once platform supports it
  return outdent`
    if (import.meta.hot) {
      import.meta.hot.accept((_) => {});
    }

    export { default } from '${originalId}';
  `;
};
